import { AverageObsProvider } from '../providers/averageObsProvider';
import { AsyncAction } from '../../base-classes/asyncAction';
import { mapParamsToObject } from '../../utilities/mapParamsToObject';

export const GET_AVERAGE_OBS_BY_LAT_LONG = new AsyncAction('GET_AVERAGE_OBS_BY_LAT_LONG');

export function getAverageObsByLatLong(...params) {

    let paramsObject = {
        latitude: undefined,
        longitude: undefined,
        startdatetimeutc: undefined,
        enddatetimeutc: undefined,
        units: undefined,
        baseUrl: undefined,
        authId: undefined,
        secret: undefined,
        stdParameters: undefined,
        verbose: undefined,
        refresh: undefined,
        lengthUnit: undefined,
        tempUnit: undefined,
        pressureUnit: undefined,
        speedUnit: undefined
    };
    paramsObject = mapParamsToObject(params, paramsObject);

    return {
        type: GET_AVERAGE_OBS_BY_LAT_LONG.base,
        payload: getAverageObs(paramsObject)
    };
}

export async function getAverageObs({ latitude, longitude, startdatetimeutc, enddatetimeutc, units, baseUrl, authId, secret, stdParameters, verbose, refresh, lengthUnit, tempUnit, pressureUnit, speedUnit }) {
    const op = new AverageObsProvider(baseUrl, authId, secret);
    return await op.getAverageObs(latitude, longitude, startdatetimeutc, enddatetimeutc, units, stdParameters, verbose, refresh, lengthUnit, tempUnit, pressureUnit, speedUnit);
}
